// extracted by mini-css-extract-plugin
export var styles = "page-title-module--styles--1hH2G";
export var zzz = "page-title-module--zzz--3BmWE";